import { media } from 'src/views/theme';
import styled from 'styled-components';

export const DesktopSection = styled.section`
  padding: 6rem calc((100% - var(--container-width)) / 2);

  ${ media.max(767) } {
    display: none;
  }
`;
